// React
import React from 'react';
import Select from 'react-select';
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  Button,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import { Currency, SelectInput } from '../../containers/componentsInjection';

export const AccountsFormPage = ({
  history,
  validation,
  accountById,
  typeOptions,
}) => {
  return (
    <div className="page-content">
      <Card>
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <CardBody>
            <Row>
              <Col xs="6" md="6">
                <div className="form-group">
                  <label htmlFor="typeAccount">Tipo</label>
                  {validation.touched.typeAccount &&
                  validation.errors.typeAccount ? (
                    <label
                      htmlFor="typeAccount"
                      className="error text-danger"
                      style={{
                        fontSize: '11px',
                        position: 'absolute',
                        right: '15px',
                      }}
                    >
                      {validation.errors.typeAccount}
                    </label>
                  ) : null}
                  <SelectInput
                    id="typeAccount"
                    inputId="typeAccount"
                    options={typeOptions}
                    value={validation.values.typeAccount}
                    onChange={(e) => {
                      validation.handleChange({
                        target: {
                          name: 'typeAccount',
                          value: e,
                        },
                      });
                    }}
                    onBlur={(e) => {
                      validation.handleBlur({
                        target: {
                          name: 'typeAccount',
                          value: e,
                        },
                      });
                    }}
                  />
                </div>
              </Col>
              <Col xs="6" md="6">
                <div className="form-group">
                  <label htmlFor="name">Nome</label>
                  {validation.touched.name && validation.errors.name ? (
                    <label
                      htmlFor="name"
                      className="error text-danger"
                      style={{
                        fontSize: '11px',
                        position: 'absolute',
                        right: '15px',
                      }}
                    >
                      {validation.errors.name}
                    </label>
                  ) : null}
                  <Input
                    type="text"
                    className="form-control"
                    id="name"
                    invalid={
                      !!(validation.touched.name && validation.errors.name)
                    }
                    value={validation.values.name}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                  />
                </div>
              </Col>
              <Col xs="6" md="6">
                <div className="form-group mt-3">
                  <label htmlFor="balance">Saldo Inicial</label>
                  {validation.touched.balance && validation.errors.balance ? (
                    <label
                      htmlFor="balance"
                      className="error text-danger"
                      style={{
                        fontSize: '11px',
                        position: 'absolute',
                        right: '15px',
                      }}
                    >
                      {validation.errors.balance}
                    </label>
                  ) : null}
                  <Currency
                    className="form-control"
                    id="balance"
                    name="balance"
                    invalid={
                      validation.touched.balance && validation.errors.balance
                    }
                    onChange={(e, valueWithoutMask) => {
                      validation.handleChange({
                        target: {
                          name: 'balance',
                          value: valueWithoutMask,
                        },
                      });
                    }}
                    onBlur={validation.handleBlur}
                    value={validation.values.balance}
                  />
                </div>
              </Col>
              <Col xs="6" md="6" className="mt-3">
                <div className="form-group">
                  <label htmlFor="dataInitialBalance">Data Inicial</label>
                  <Input
                    type="date"
                    className="form-control"
                    id="dataInitialBalance"
                    invalid={
                      !!(
                        validation.touched.dataInitialBalance &&
                        validation.errors.dataInitialBalance
                      )
                    }
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.dataInitialBalance}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Row>
              <Col xs="12" md="12">
                <div className="form-group d-flex justify-content-end align-items-center">
                  <Button
                    style={{
                      marginRight: '10px',
                    }}
                    color="transparent"
                    className="btn btn-link"
                    onClick={() => history.goBack()}
                  >
                    Cancelar
                  </Button>
                  <Button color="primary" type="submit" className="mr-1">
                    {accountById?.id ? 'Editar' : 'Salvar'}
                  </Button>
                </div>
              </Col>
            </Row>
          </CardFooter>
        </Form>
      </Card>
    </div>
  );
};
